/**
 * Router-aware navigation for code that lives outside React (notification
 * helpers, service-worker messages). `PushLaunchBridge` registers the
 * router's `navigate` while the authenticated shell is mounted.
 */

type Navigate = (to: string) => void;

let current: Navigate | null = null;

/** Returns an unregister function; a stale unregister never clears a newer one. */
export const registerAppNavigator = (navigate: Navigate): (() => void) => {
  current = navigate;
  return () => {
    if (current === navigate) current = null;
  };
};

/** Navigate in place. False when no router is mounted (caller falls back). */
export const navigateInApp = (to: string): boolean => {
  if (!current) return false;
  current(to);
  return true;
};
